<template>
  <div>Подтверждение ок</div>
</template>

<script>
export default {
  data: function () {
    return {
      //
    };
  },
  props: {
    //
  },
  components: {
    //
  },
  methods: {
    //
  },
};
</script>
